export default __webpack_public_path__ + "static/media/Series-X-2.83788740.jpg";